import { ReactNode } from "react"
import styled from "styled-components"

import Typography from "~/components/atoms/Typography"
import { Color, RadiusSize, SpacingSize } from "~/consts/style-mixins"

interface Props {
  children: ReactNode
  className?: string
}

const HeadingPrimary = ({ children, className }: Props) => {
  return (
    <Heading type="Label" colorProp={Color.Primary} className={className}>
      {children}
    </Heading>
  )
}

const Heading = styled(Typography)`
  background: ${Color.BackgroundGray};
  padding: ${SpacingSize.XS}px ${SpacingSize.S}px;
  border-radius: ${RadiusSize.Medium}px;
`

export default HeadingPrimary
